module.exports = __webpack_public_path__ + "media/images/proof_links/colored/airbnb-f8f8ec1ce252cbf4bd9ea754675d73ab.svg";